import OptionsPanel from "./OptionsPanel.js"

export default class ScrollType extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Scroll Type" // TODO: This needs to be localized
    this.setting = "scroll"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
